import { Storage, StorageConfig } from '@ionic/storage';

/**
 * Reference: Ionic Storage w/ Multiple Tables
 * https://stackoverflow.com/a/58368895/12734092
 *
 * Reference: On Bulk operation performance
 * https://stackoverflow.com/a/52555073/12734092
 */
export class LocalStorage {
	store: Storage;

	constructor(storeConfig: StorageConfig) {
		this.store = new Storage(storeConfig);
	}

	keys(): Promise<any[]> {
		return this.store.keys();
	}

	setItem(key: string | number, value: any): Promise<void> {
		return this.store.set(`${key}`, value);
	}

	async bulkSet(items = [], index = 'id') {
		await this.clear();

		if (items == null || items.length < 1) {
			return;
		}

		for (const item of items) {
			await this.setItem(item[index], item);
		}
	}

	getItem<T>(key: string | number): Promise<T> {
		return this.store.get(`${key}`);
	}

	getAll(): Promise<any[]> {
		return new Promise(
			(resolve, reject) => {
				const all = [];
				this.store.forEach((value, _) => {
					all.push(value);
				})
					.then(() => resolve(all))
					.catch(err => reject(err));
			}
		);
	}

	async getAllSortedBy(key: string | number, order = 'asc'): Promise<any[]> {
		const entries = await this.getAll();
		return entries.sort(this.compareValues(`${key}`, order));
	}

	removeItem(key: string): Promise<void> {
		return this.store.remove(key);
	}

	clear(): Promise<void> {
		return this.store.clear();
	}

	length(): Promise<number> {
		return this.store.length();
	}

	ready(): Promise<any> {
		return this.store.ready();
	}

	private compareValues(key, order = 'asc') {
		return function innerSort(a, b) {
			if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
				// property doesn't exist on either object
				return 0;
			}

			const varA = (typeof a[key] === 'string')
				? a[key].toUpperCase() : a[key];
			const varB = (typeof b[key] === 'string')
				? b[key].toUpperCase() : b[key];

			let comparison = 0;
			if (varA > varB) {
				comparison = 1;
			} else if (varA < varB) {
				comparison = -1;
			}
			return (
				(order === 'desc') ? (comparison * -1) : comparison
			);
		};
	}
}
